<template>
    <div ref="rootEl" class="c-latest-insights__layout">
        <div class="js-insights-rotator swiper" :data-pod-id="podID">
            <div class="c-latest-insights__slides swiper-wrapper">

				<div class="c-latest-insights__slide swiper-slide" v-for="(item, index) in insights" :key="index">
					<insight-tile :item="item"></insight-tile>
				</div>

			</div>
		</div>
	</div>
</template>
<script setup>

    import { ref, onMounted, nextTick } from 'vue'
    import { TeraSwiper } from 'App/rotator/tera-swiper'

    const insights = ref([])
    const podID = ref(null)
    const rootEl = ref(null)

    const initSwiper = () => {
        const $rotator = rootEl.value.querySelector(`.js-insights-rotator[data-pod-id="${podID.value}"]`)

        const $controlParent = $rotator.closest('.c-latest-insights')?.querySelector('.c-latest-insights-rotator__control')

        const latestInsightsRotatorSettings = {
            wrapperClass: 'c-latest-insights__slides',
            slideClass: 'c-latest-insights__slide',
            loop: false,
            containerQuery: true,
            spaceBetween: 20,
            navigation: {
                nextEl: '.c-latest-insights-rotator__control-next[data-pod-id="' + podID.value + '"]',
                prevEl: '.c-latest-insights-rotator__control-prev[data-pod-id="' + podID.value + '"]',
            },
            slidesPerView: 1.2,
            breakpoints: {
                767: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 }
            }
        }

        TeraSwiper.init($rotator, latestInsightsRotatorSettings, $controlParent)
    }

    onMounted(() => {
        const baseUrl = window.location.origin

        const DataProp = rootEl.value.parentElement
        const DataAPI = DataProp?.getAttribute('data-latestinsights-api')
        const ID = DataProp?.getAttribute('data-pod-id')

        fetch(baseUrl + DataAPI).then(res => res.json()).then(response => {

            const toDate = (val) => {
                const d = new Date(val);
                // Treat unset dates (DateTime.MinValue = 0001-01-01) as oldest
                return isNaN(d.getTime()) || d.getFullYear() <= 1 ? new Date(0) : d;
            };

            insights.value = (response.items || []).sort((a, b) => toDate(b.articleDate) - toDate(a.articleDate))
            podID.value = ID

            nextTick(() => {
                initSwiper()
            })

        }).catch((err) => {
            console.log("catch", err)
        })
    })

</script>